import { styled } from '../../../styled';

export const Container = styled.div``;
